import React from 'react'
import ReactDOM from 'react-dom'
import App from 'App'
import createStore from 'store/createStore'
import 'assets/scss/tailwind.scss'
import 'assets/fonts/icon/icon-teacher-web.css'
import 'assets/scss/main.scss'

export const store = createStore(window.__INITIAL_STATE__)
const MOUNT_NODE = document.getElementById('root')
const routes = require('./routes/index').default(store)

ReactDOM.render(
  <React.StrictMode>
    <App routes={routes} store={store} />
  </React.StrictMode>,
  MOUNT_NODE
)